import { useReservation } from "@/contexts/reservation";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import useFormHistory from "./useFormHistory";
import { AccrualResponse } from "@/types/cashback";

type useRescueResult = UseQueryResult<AccrualResponse>;

export function useRescue(): useRescueResult {
  const { depot, itinerary, estimate } = useReservation();
  const { condutor } = useFormHistory();

  const days = estimate && estimate.DAYS ? parseInt(estimate.DAYS.quantity) : 1;
  const dailyPrice = estimate && estimate.DAYS ? estimate.DAYS.total / days : 0;

  const body = {
    storeId: depot?.coral_code,
    days,
    dailyPrice,
    pickupDate: `${itinerary?.pickup_date}T${itinerary?.pickup_time}:00`,
    email: condutor?.email,
    documentNumber: condutor?.cpf,
    isCalculate: true,
  }

  const { data, ...query } = useQuery({
    queryKey: ['cashback', 'rescue'],
    queryFn: async () => {
      const response = await fetch(`/api/cashback/rescue`, {
        method: 'POST',
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        return {
          success: false,
        }
      }

      return response.json();
    }
  });

  return {
    data,
    ...query,
  }
}
